import React from "react";
import Blog_52 from "../component/Blog_52";
function Blog_52_container() {
  return <Blog_52 />;
}

export default Blog_52_container;
